import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { ContactSupport as SupportIcon } from "@mui/icons-material";
import { motion } from "framer-motion";

const Support = () => {
  return (
    <Box>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
            Support Tickets
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            Manage customer support tickets and issues
          </Typography>
        </Box>
        <Card>
          <CardContent>
            <Typography variant="body1" sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
              Support ticket management system coming soon...
            </Typography>
          </CardContent>
        </Card>
      </motion.div>
    </Box>
  );
};

export default Support;

